/* Auto generated by gulp-typescript-template */

export const textTemplate = `<div class="content-item -para  content-item-layout"></div>`;
